import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  async getDocumentCounterpointInstructions(teamID) {
    return await picador.get('getDocumentCounterpointInstructions', xhrPath.instructions(teamID));
  },

  async updateDocumentCounterpointInstructions(teamID, generalInstructions) {
    return await picador.put(
      'updateDocumentCounterpointInstructions',
      xhrPath.instructions(teamID),
      generalInstructions
    );
  },

  async updateDocumentCounterpointInstructionsViewed(teamID) {
    return await picador.put(
      'updateDocumentCounterpointInstructionsViewed',
      `${xhrPath.instructions(teamID)}/viewed`
    );
  },
};
